<!-- 考场列表 -->
<template>
  <div class="exam">
    <el-dialog title="考试报名" width="500px" :visible.sync="show">
      <el-form
        ref="form"
        :model="addParams"
        :rules="addRules"
        label-width="80px"
      >
        <el-form-item label="报名考试" prop="subjectName">
          <el-input v-model="addParams.subjectName" disabled></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="userName">
          <el-input
            v-model="addParams.userName"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phoneNo">
          <el-input
            type="number"
            v-model="addParams.phoneNo"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="专业名称"
          prop="workTypeName"
          v-if="addParams.subjectCode == 'ZYJS'"
        >
          <el-input
            v-model="addParams.workTypeName"
            placeholder="请输入专业名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="职称等级"
          prop="subjectLevel"
          v-if="addParams.subjectCode == 'ZYJS'"
        >
          <el-select
            v-model="addParams.subjectLevel"
            placeholder="请选择职称等级"
          >
            <el-option label="中级职称" value="中级"></el-option>
            <el-option label="高级职称" value="高级"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="岗位名称"
          prop="workTypeName"
          v-if="addParams.subjectCode == 'ZYJN'"
        >
          <el-input
            v-model="addParams.workTypeName"
            placeholder="请输入岗位名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="工作单位"
          prop="companyName"
          v-if="addParams.subjectCode == 'ZYJN'"
        >
          <el-input
            v-model="addParams.companyName"
            placeholder="请输入工作单位"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="工种"
          prop="workTypeName"
          v-if="['GCJX', 'ZYZG'].includes(addParams.subjectCode)"
        >
          <el-input
            v-model="addParams.workTypeName"
            placeholder="请输入工种"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="cancelApply">取消</el-button>
        <el-button type="primary" :loading="loading" @click="confirmApply"
          >报名</el-button
        >
      </span>
    </el-dialog>
    <div class="wrap">
      <div class="my">
        <div class="label-title">
          <span>我的考试</span>
        </div>
        <div class="list">
          <div
            class="item"
            v-for="item in list"
            :key="item.id"
            @click="navExamDetail(item)"
          >
            <img :src="URL + item.imageUrl" class="post" v-if="item.imageUrl" />
            <img
              src="http://scjxrc.org.cn/static/16370375619575.jpg"
              class="post"
              v-else
            />
            <div class="desc">
              <div class="title">{{ item.paperTitle }}</div>
              <div class="sub">{{ item.subjectName }}</div>
              <div class="typename" v-show="item.workTypeName">
                工种：{{ item.workTypeName }}
              </div>
            </div>
          </div>
        </div>
        <div class="empty" v-show="list.length == 0">
          <el-empty description="暂无可考试卷"></el-empty>
        </div>
      </div>
      <div class="all">
        <div class="label-title">
          <span>最新考试</span>
        </div>
        <div class="news">
          <div
            class="new"
            v-for="item in subjectList"
            :key="item.id"
            @click="applySubject(item)"
          >
            <img
              src="http://scjxrc.org.cn/static/16370375619575.jpg"
              class="post"
            />
            <div class="desc">
              <div class="title">{{ item.subjectName }}</div>
            </div>
            <div class="status">
              <!-- <div class="info" v-if="item.apply == 0">报名中</div>
              <div class="success" v-else-if="item.apply == 1">可考试</div> -->
              <div class="primary">可报名</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { URL } from "../util/config";
export default {
  data() {
    return {
      URL,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
      },
      list: [],
      totalData: 0,
      subjectList: [],
      show: false,
      addParams: {
        subjectName: "",
        subjectCode: "", // 用于区分报名时应该填写哪些必填字段
        userName: "",
        phoneNo: "",
        companyName: "", // 工作单位
        workTypeName: "", // 工种
        subjectLevel: "", // 职称等级-报考专业技术时需要
      },
      addRules: {
        userName: { required: true, message: "请输入姓名", trigger: "blur" },
        subjectLevel: {
          required: true,
          message: "请选择职级等级",
          trigger: "change",
        },
        workTypeName: {
          required: true,
          message: "请输入内容",
          trigger: "blur",
        },
      },
      userInfo: {},
      loading: false,
    };
  },
  created() {
    let json = localStorage.getItem("userInfo");
    if (json) {
      this.userInfo = JSON.parse(json);
    }
    // 获取可报名的证书类型
    this.$api.getCertificateTypes().then((res) => {
      if (res.code == 0) {
        this.subjectList = res.data.map((ele) => {
          ele.apply = -1; // 用户的报名状态
          return ele;
        });
        this.getMyApply();
      }
    });

    this.getList();
  },
  methods: {
    async getList() {
      let res = await this.$api.getMyPaper();
      this.list = res.data;
    },
    // 前往考场详情
    navExamDetail(item) {
      const myApply = this.subjectList.find(
        (ele) => ele.subjectName == item.subjectName
      ); // 获取当前试卷所属的报名信息
      this.$router.push("/examTip/" + item.id + "?applyId=" + myApply.applyId);
    },
    async getMyApply() {
      let res = await this.$api.getMyApplyList({ pageIndex: 1, pageSize: 100 });
      const unableStatus = [0, 1]; // 未完成的状态
      const data = res.data.list.filter((ele) => {
        return unableStatus.includes(ele.status);
      });
      this.subjectList.forEach((ele) => {
        const findData = data.find((val) => val.subjectName == ele.subjectName);
        if (findData) {
          ele.applyId = findData.id;
          ele.apply = findData.status; // 若存在，则表明该证书已被报名
        }
      });
    },
    // 证书报名
    applySubject(item) {
      Object.assign(this.$data.addParams, this.$options.data().addParams);
      // if (item.apply == -1) {
      this.addParams.subjectName = item.subjectName;
      this.addParams.subjectCode = item.code;
      this.addParams.userName = this.userInfo.trainUserName;
      this.addParams.phoneNo = this.userInfo.phoneNo;
      this.addParams.workTypeName = this.userInfo.workTypeName;
      this.show = true;
      // }
    },
    cancelApply() {
      this.$refs.form.clearValidate();
      this.show = false;
    },
    confirmApply() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$api
            .applyCertificate(this.addParams)
            .then((res) => {
              if (res.code == 0) {
                this.$notify.success({ title: "申请成功!" });
                this.show = false;
                this.getMyApply();
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.exam {
  background-color: #e9eaed;
}
.wrap {
  width: 1200px;
  min-height: calc(100vh - 285px);
  margin: 0 auto;
  padding: 30px 0;
  box-sizing: border-box;
  display: flex;

  .my {
    width: 780px;
    margin-right: 20px;
    background-color: #fff;
    border-radius: 5px;
    padding: 10px;
    box-sizing: border-box;
  }
  .all {
    width: 400px;
    background-color: #fff;
    border-radius: 5px;
    padding: 10px;
    box-sizing: border-box;
  }

  .label-title {
    padding: 0 20px 0 30px;
    margin-bottom: 30px;
    position: relative;

    &::before {
      content: "";
      width: 100%;
      height: 1px;
      background: #ccc;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }

    span {
      padding: 5px 20px;
      border-radius: 18px;
      background: #a4a4a4;
      color: #fff;
      position: relative;
      z-index: 2;

      &::before,
      &::after {
        content: "";
        width: 7px;
        height: 7px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background: #ccc;
        border-radius: 50%;
      }
      &::before {
        left: -20px;
      }
      &::after {
        right: -20px;
      }
    }
  }

  .list {
    padding: 0 10px;
    display: flex;
    flex-wrap: wrap;

    .item {
      width: 32%;
      margin: 0 1% 10px 0;
      box-sizing: border-box;
      border-radius: 5px;
      overflow: hidden;
      transition: 0.5s;
      box-shadow: 0 0 10px 0 rgba(95, 101, 105, 0.15);

      &:nth-child(3n) {
        margin-right: 0;
      }

      &:hover {
        transform: translateY(-5px);
        cursor: pointer;

        .title {
          color: $theme;
        }
      }

      .post {
        width: 100%;
        height: 140px;
        object-fit: cover;
      }
      .desc {
        padding: 10px 10px 20px;
      }
      .title {
        font-weight: bold;
        margin-bottom: 10px;
      }
      .sub {
        font-size: 14px;
        color: #999;
        margin-bottom: 10px;
      }
      .typename {
        color: $theme;
        font-size: 12px;
      }
    }
  }

  .news {
    .new {
      padding: 10px;
      border-bottom: 1px solid #eee;
      display: flex;
      position: relative;

      &:last-child {
        border-bottom: none;
      }
      &:hover {
        cursor: pointer;
        background-color: #eee;
      }

      .post {
        width: 130px;
        height: 75px;
        border-radius: 5px;
        margin-right: 10px;
      }
      .title {
        font-size: 15px;
        margin-top: 22px;
      }
      .status {
        position: absolute;
        right: 10px;
        top: 10px;
        border-top-right-radius: 8px;
        border-bottom-left-radius: 8px;
        overflow: hidden;
        color: #fff;
        font-size: 12px;
      }
      .primary {
        background-color: #409eff;
        padding: 2px 5px;
      }
      .success {
        background-color: #67c23a;
        padding: 2px 5px;
      }
      .info {
        background-color: #909399;
        padding: 2px 5px;
      }
    }
  }
}
</style>
